module.exports = __webpack_public_path__ + "img/photo5-1.cfa60a88.png";